export default __webpack_public_path__ + "static/media/pt.cf2d92a6.svg";